import { useTunnels } from "@excalidraw/excalidraw/context/tunnels";
import DropdownMenu from "@excalidraw/excalidraw/components/dropdownMenu/DropdownMenu";
import { OpenAIIcon } from "@excalidraw/excalidraw/components/icons";
import { useSetAtom } from "../app-jotai";
import { promptToTextDialogOpenAtom } from "./PromptToText";
import { promptToImageDialogOpenAtom } from "./PromptToImage";
import { trackEvent } from "@excalidraw/excalidraw/analytics";

import type { JSX, ReactNode } from "react";

/**
 * Trigger for Prompt to Text dialog - renders in the toolbar
 */
export const PromptToTextTrigger = ({
  children,
  icon,
}: {
  children?: ReactNode;
  icon?: JSX.Element;
}) => {
  const { TTDDialogTriggerTunnel } = useTunnels();
  const setPromptToTextOpen = useSetAtom(promptToTextDialogOpenAtom);

  return (
    <TTDDialogTriggerTunnel.In>
      <DropdownMenu.Item
        onSelect={() => {
          trackEvent("ai", "dialog open", "prompt-to-text");
          setPromptToTextOpen(true);
        }}
        icon={icon ?? OpenAIIcon}
        data-testid="toolbar-prompt-to-text"
      >
        {children ?? "Prompt to Text"}
        <DropdownMenu.Item.Badge>AI</DropdownMenu.Item.Badge>
      </DropdownMenu.Item>
    </TTDDialogTriggerTunnel.In>
  );
};
PromptToTextTrigger.displayName = "PromptToTextTrigger";

/**
 * Trigger for Prompt to Image dialog - renders in the toolbar
 */
export const PromptToImageTrigger = ({
  children,
  icon,
}: {
  children?: ReactNode;
  icon?: JSX.Element;
}) => {
  const { TTDDialogTriggerTunnel } = useTunnels();
  const setPromptToImageOpen = useSetAtom(promptToImageDialogOpenAtom);

  return (
    <TTDDialogTriggerTunnel.In>
      <DropdownMenu.Item
        onSelect={() => {
          trackEvent("ai", "dialog open", "prompt-to-image");
          setPromptToImageOpen(true);
        }}
        icon={icon ?? OpenAIIcon}
        data-testid="toolbar-prompt-to-image"
      >
        {children ?? "Prompt to Image"}
        <DropdownMenu.Item.Badge>AI</DropdownMenu.Item.Badge>
      </DropdownMenu.Item>
    </TTDDialogTriggerTunnel.In>
  );
};
PromptToImageTrigger.displayName = "PromptToImageTrigger";
